import React from 'react';
import { ChannelBackgroundPreviewZone, ImageButton } from '../style';
import { config } from '../../../../../Configurations';
import { ConditionalOverlayWrapper } from '../OverlayWrapper';

export const BackgroundPreview = ({ background, name, onChange, value, isDarkeningLayerApplied }) => {
    return (
        <div>
            <ChannelBackgroundPreviewZone background={background || `${config.baseUrl}/${value}`}>
                <ImageButton htmlFor={name}>Edit</ImageButton>
                <input onChange={onChange} name={name} id={name} type={'file'} style={{ display: 'none' }} />
                <ConditionalOverlayWrapper isApplied={false} />
            </ChannelBackgroundPreviewZone>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/GymTv/Settings/BackgroundPreview.js